import { yupResolver } from '@hookform/resolvers/yup'
import { Dialog, DialogTitle, DialogContent } from '@mui/material'
import { BorderLineSuccess, Span, Form, Row, Button, Input } from 'components'
import { useForm } from 'react-hook-form'
import { COLORS, FONTS, SPACING, TYPOGRAPHY } from 'utils'
import * as yup from 'yup'

interface PasswordRecoveryProps {
  email: string
}

const schema = yup.object({
  email: yup
    .string()
    //.email('Digite um e-mail valido!')
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, 'Digite um email válido') 
    .required('E-mail deve ser informado!')
})

export const PasswordRecoveryModal = ({ open, handleClose, onSubmit }) => {
  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm<PasswordRecoveryProps>({
    resolver: yupResolver(schema)
  })

  return (
    <Dialog open={open} onClose={handleClose}>
      <BorderLineSuccess colorLine={COLORS.secondary} />
      <DialogTitle>
        <Row marginBottom={SPACING.spacing20}>
          <Span
            marginTop={SPACING.spacing10}
            text="Recuperação de Senha"
            fontSize={TYPOGRAPHY.subtitleSize20}
            fontWeight={FONTS.bold}
          />
        </Row>
        <Row>
          <Span
            marginTop={SPACING.spacing10}
            text="Enviaremos um e-mail com mais informações sobre como redefinir sua senha."
            color={COLORS.black}
            fontSize={TYPOGRAPHY.bodySize16}
            fontWeight={FONTS.bold}
          />
        </Row>
      </DialogTitle>
      <DialogContent>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Row marginBottom={SPACING.spacing30}>
            <Input
              width={SPACING.spacing300}
              formValue="email"
              control={control}
              errors={errors}
              label="E-mail"
              placeholder="E-mail cadastrado"
              required
            />
          </Row>
          {/* <Row marginBottom={SPACING.spacing30}>
            <Input
              formValue="newPassword"
              control={control}
              label="Nova Senha "
              placeholder="Nova Senha"
              required
            />
          </Row> */}
          <Row marginBottom={SPACING.spacing15} justifyContent="flex-end">
            <Button
              text="Voltar"
              variantButton="outlined"
              backgroundColor={COLORS.white}
              textColor={COLORS.black}
              marginRight={SPACING.spacing20}
              borderColor={COLORS.black}
              onClick={handleClose}
            />
            <Button text="recuperar senha" type="submit" />
          </Row>
        </Form>
      </DialogContent>
    </Dialog>
  )
}
